import {RestDataLoader} from "../dashboard/widgets/unilever/RestDataLoader";
import React = require("react");

export interface ProtectedImageDisplayProps extends React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement> {
    src: string;
    alt: string;
    key: string;
    className?: string;
}

export const ProtectedImageDisplay: React.FC<ProtectedImageDisplayProps> = ({
                                                                                src,
                                                                                key,
                                                                                alt,
                                                                                className,
                                                                                ...rest
                                                                            }) => {
    const [loading, setLoading] = React.useState(true);
    const [imageUrl, setImageUrl] = React.useState("");
    React.useEffect(() => {
        RestDataLoader.protectedImageUrl(src, "")
            .then(setImageUrl)
            .then(() => setLoading(false));
    }, [src])
    return (
        <img
            className={"c-image " + (loading ? "skeleton" : "") + className}
            src={imageUrl}
            alt={alt}
            key={key}
            {...rest}
        />
    );
}